import { createOutlineIcon } from "../createIcon";

export const ArrowRightOutlineIcon = createOutlineIcon(
  <>
    <path d="M13.3333 5L20 12M20 12L13.3333 19M20 12L4 12" />
  </>,
  "ArrowRightOutlineIcon"
);
